import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { Vec2 } from '../../components';
import { toProps } from '../../core';

function toSkyProps(_ref) {
  var color = _ref.color,
      metalness = _ref.metalness,
      opacity = _ref.opacity,
      phiLength = _ref.phiLength,
      phiStart = _ref.phiStart,
      radius = _ref.radius,
      repeat = _ref.repeat,
      roughness = _ref.roughness,
      segmentsHeight = _ref.segmentsHeight,
      segmentsWidth = _ref.segmentsWidth,
      shader = _ref.shader,
      side = _ref.side,
      src = _ref.src,
      thetaLength = _ref.thetaLength,
      thetaStart = _ref.thetaStart,
      transparent = _ref.transparent;
  return {
    color: color,
    metalness: metalness,
    opacity: opacity,
    'phi-length': phiLength,
    'phi-start': phiStart,
    radius: radius,
    repeat: repeat && new Vec2(repeat).toString(),
    roughness: roughness,
    'segments-height': segmentsHeight,
    'segments-width': segmentsWidth,
    shader: shader,
    side: side,
    src: src,
    'theta-length': thetaLength,
    'theta-start': thetaStart,
    transparent: transparent
  };
}
/**
 * The sky primitive adds a background color or 360° image to a scene.
 * A sky is a large sphere with a color or texture mapped to the inside.
 *
 * @see https://aframe.io/docs/1.3.0/primitives/a-sky.html
 *
 * @example
 * An equirectangular image as a background:
 *
 * ```tsx
 * <Scene>
 *   <Assets>
 *     <img id="sky" src="sky.png" />
 *   </Assets>
 *   <Sky src="#sky" />
 * </Scene>
 * ```
 *
 * A plain color as a background:
 *
 * ```tsx
 * <Sky color="#6EBAA7" />
 * ```
 */


export default function Sky(props) {
  var skyKeys = ['color', 'metalness', 'opacity', 'phiLength', 'phiStart', 'radius', 'repeat', 'roughness', 'segmentsHeight', 'segmentsWidth', 'shader', 'side', 'src', 'thetaLength', 'thetaStart', 'transparent'];
  var children = props.children;
  return /*#__PURE__*/React.createElement("a-sky", _extends({}, toProps(props, skyKeys), toSkyProps(props)), children);
}